// https://api.zerek.edus.kz/
// http://192.168.31.137:8000/

module.exports = {
  API_URL: "https://api.gos.zerek.edus.kz/",
  API_VERSION: "v1",
};
